import React from 'react'
import NumericButton from './NumericButton'

interface NumericKeyboardProps {
  onNumberPress: (number: string) => void
  onDeletePress: () => void
  disabled?: boolean
  includeDecimal?: boolean
}

const NumericKeyboard: React.FC<NumericKeyboardProps> = ({ 
  onNumberPress, 
  onDeletePress,
  disabled = false,
  includeDecimal = false
}) => {
  const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
  
  return (
    <div className="flex flex-col items-center w-full" style={{ direction: 'ltr' }}>
      {/* Grid layout for consistent alignment */}
      <div className="grid grid-cols-3 gap-[clamp(9px,1vw,12px)] w-full">
        {/* Top rows (1-9) */}
        {numbers.map(number => (
          <NumericButton
            key={number}
            text={number}
            onPress={() => onNumberPress(number)}
            disabled={disabled}
          />
        ))}
        
        {/* Bottom row - 3 buttons in same grid */}
        {includeDecimal ? (
          <>
            <NumericButton text="0" onPress={() => onNumberPress('0')} disabled={disabled} />
            <NumericButton text="." onPress={() => onNumberPress('.')} disabled={disabled} />
            <NumericButton text="Del" onPress={onDeletePress} isDelete={true} disabled={disabled} />
          </>
        ) : (
          <>
            <NumericButton text="0" onPress={() => onNumberPress('0')} disabled={disabled} />
            <NumericButton text="Del" onPress={onDeletePress} isDelete={true} disabled={disabled} className="col-span-2" />
          </>
        )}
      </div>
    </div>
  )
}

export default NumericKeyboard
